import { useMutation } from "react-query";
import downloadMembership from "../services/downloadMembership";

function useMemberShip() {
  return useMutation(["get-membership"], downloadMembership);
}

export default useMemberShip;
